<template>
  <b-form @submit.prevent="handleSubmit">
    <h2>New Password</h2>
    <b-form-row>
      <b-col>
        <b-form-group>
          <b-input
            type="password"
            name="currentPassword"
            id="currentPassword"
            placeholder="Current Password"
            autofocus
            required
            v-model="currentPassword"
          />
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col>
        <b-form-group>
          <b-input
            type="password"
            name="newPassword"
            id="newPassword"
            placeholder="New Password"
            autofocus
            required
            v-model="newPassword"
          />
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col>
        <b-form-group>
          <PasswordRequirements :requirements="passwordRequirements" />
        </b-form-group>
      </b-col>
    </b-form-row>

    <SubmitButton :disabled="!canSubmit">Change Password</SubmitButton>
  </b-form>

</template>

<script>
import newPassword from '@/mixins/newPassword';

import PasswordRequirements from '@/components/login/PasswordRequirements.vue';
import SubmitButton from '@/components/login/SubmitButton.vue';

export default {
  name: 'ChangePasswordForm',
  mixins: [
    newPassword
  ],
  components: {
    PasswordRequirements,
    SubmitButton
  },
  data() {
    return {
      currentPassword: ''
    }
  },
  computed: {
    canSubmit() {
      return this.passwordRequirementsMet;
    }
  },
  methods: {
    handleSubmit() {
      if (this.canSubmit) {
        const { currentPassword, newPassword } = this;
        this.$store.dispatch('ping/changePassword', ({
          currentPassword,
          newPassword
        }))
      }
    }
  }
};
</script>
